// initial state
const state = {
  i18n: undefined,
  refreshRate: undefined,
};

const actions = {};

const mutations = {
  setI18n(state, i18n) {
    state.i18n = i18n;
  },
  setRefreshRate(state, refreshRate) {
    state.refreshRate = refreshRate;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
